const LIGHT_THEME = {
  // Primary palette
  BUNKER: '#070C10',
  GEYSER: '#D1D7DD',
  ATHENS_GRAY: '#E2E3EB',
  SECONDARY_ATHENS_GRAY: '#E4E7EC',
  CATSKILL_WHITE: '#EAEDF4',
  POLAR: '#e5f2fa',
  BLACK_HAZE: '#e9eaea',
  GALLERY: '#EFEFEF59',
  // Secondary palette
  AZTEC: '#0A1418',
  SECONDARY_BUNKER: '#151E21',
  OUTER_SPACE: '#273136',
  SLATE_GRAY: '#6E7F8D',
  LOCHMARA: '#0083ce',
  WHITE: '#FFFFFF',
  RED_ORANGE: '#FA2E2E',

  // Additionals
  SANDY_BROWN: '#F6A15B',
  FERN: '#56B158',
  SECONDARY_FERN: '#55B357',
  PELOROUS: '#49B0C5',
  CARNATION: '#F44D6C',
  GOLDEN_GRASS: '#E3AD25',
  JELLY_BEAN: '#2974B3',
  RIPE_LEMON: '#F3DF26',
  MALIBU: '#6BBBFF',
  CHETWODE_BLUE: '#7285D5',
  SAFFRON: '#F7C630',
  OVERLAY: 'rgba(0,0,0,0.6)',

  CARD_BACKGROUND: '#FFFFFF',
  CARD_MAIN_TEXT: '#273136',
  CARD_NORMAL_TEXT: '#6E7F8D',
  WHITE_TEXT: '#FFFFFF',
  SLATE_GRAY_TEXT: '#6E7F8D',
  INPUT_COLOR: '#D1D7DD',
  ICON_COLOR: '#0A1418',
  DISABLED_COLOR: '#D1D7DD',
  DISABLED_INPUT_COLOR: '#F4F4F4',
  SECOND_DISABLED_COLOR: '#6E7F8D99',
  BUNKER_TEXT: '#070C10'
}

const DARK_THEME = {
  // Primary palette
  BUNKER: LIGHT_THEME.WHITE,
  GEYSER: '#D1D7DD',
  ATHENS_GRAY: '#E2E3EB',
  SECONDARY_ATHENS_GRAY: '#E4E7EC',
  CATSKILL_WHITE: LIGHT_THEME.OUTER_SPACE,
  POLAR: `${LIGHT_THEME.LOCHMARA}66`,
  BLACK_HAZE: '#e9eaea',
  GALLERY: '#EFEFEF33',
  // Secondary palette
  AZTEC: LIGHT_THEME.WHITE,
  SECONDARY_BUNKER: '#0D171C',
  OUTER_SPACE: LIGHT_THEME.CATSKILL_WHITE,
  SLATE_GRAY: '#6E7F8D',
  LOCHMARA: '#0083ce',
  WHITE: LIGHT_THEME.BUNKER,
  RED_ORANGE: '#FA2E2E',

  // Additionals
  SANDY_BROWN: '#F6A15B',
  FERN: '#56B158',
  SECONDARY_FERN: '#55B357',
  PELOROUS: '#49B0C5',
  CARNATION: '#F44D6C',
  GOLDEN_GRASS: '#E3AD25',
  JELLY_BEAN: '#2974B3',
  RIPE_LEMON: '#F3DF26',
  MALIBU: '#6BBBFF',
  CHETWODE_BLUE: '#7285D5',
  SAFFRON: '#F7C630',
  OVERLAY: 'rgba(0,0,0,0.6)',

  CARD_BACKGROUND: LIGHT_THEME.BUNKER,
  CARD_MAIN_TEXT: LIGHT_THEME.SLATE_GRAY,
  CARD_NORMAL_TEXT: `${LIGHT_THEME.CARD_NORMAL_TEXT}99`,
  WHITE_TEXT: LIGHT_THEME.WHITE_TEXT,
  SLATE_GRAY_TEXT: LIGHT_THEME.WHITE,
  INPUT_COLOR: LIGHT_THEME.SLATE_GRAY,
  ICON_COLOR: LIGHT_THEME.SLATE_GRAY,
  DISABLED_COLOR: LIGHT_THEME.AZTEC,
  SECOND_DISABLED_COLOR: LIGHT_THEME.SECOND_DISABLED_COLOR,
  BUNKER_TEXT: LIGHT_THEME.BUNKER_TEXT
}

export default {
  LIGHT_THEME,
  DARK_THEME
}
